module.exports = "/images/google-login-callback-cover.png?bac42d8822faa4eb0f105cd06a70ef45";